module.exports = __webpack_public_path__ + "media/images/athletes/1564-2ae780f8b21f27bc471835606411e0a7.png";